import React from 'react';
import './NormalHeaderComponent.css';
import logo3 from '../../assets/images/logo4.png';

function NormalHeaderComponent () {
  return (
    <div className="header_containerH">

      <img src={logo3} alt="logo" width="200px" />

    </div>
  );
}

export default NormalHeaderComponent;
